import { map } from 'lodash';

const actions = {
  /**
   * Fetch credits percentage use.
   *
   * @param $http
   * @param commit
   */
  async fetchCreditsPercentageUse({ rootState: { $http }, commit }) {
    const { data } = await $http.get('/user/metric/percentage-use');

    commit('setCreditsPercentageUse', data.value);
  },

  /**
   * Fetch credits use from last 30 days.
   *
   * @param $http
   * @param commit
   */
  async fetchCreditsUseLast30Days({ rootState: { $http }, commit }) {
    const { data } = await $http.get('/user/metric/credits-last-30-days');

    commit('setCreditsUseLast30Days', data.value);
  },

  /**
   * Fetch credits use from today.
   *
   * @param $http
   * @param commit
   */
  async fetchCreditsUseToday({ rootState: { $http }, commit }) {
    const { data } = await $http.get('/user/metric/credits-today');

    commit('setCreditsUseToday', data.value);
  },

  /**
   * Fetch credits use last 30 days chart.
   *
   * @param $http
   * @param commit
   */
  async fetchCreditsUseLast30DaysChart({ rootState: { $http }, commit }) {
    const { data } = await $http.get('/user/metric/credits-last-30-days-chart');

    let xAxis = [];
    let series = [];

    if (data.length > 0) {
      xAxis = map(data[0].data, 'date');
      series = data.map((serie) => ({
        name: serie.name,
        data: map(serie.data, 'total'),
      }));
    }

    commit('setCreditsUseLast30DaysChartXAxis', xAxis);
    commit('setCreditsUseLast30DaysChartSeries', series);
  },
};

export default actions;
